module.exports = __webpack_public_path__ + "assets/img/202107-2W.f0997752.png";